import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Customer } from '@uxdf/direct-shared-lib';
import { AgentState } from '../../../../redux/models/loyalty/agent.state';
import { AlreadyGetNumber } from '../../../../redux/actions/loyalty/actions-agent';

@Component({
  standalone: false,
  selector: 'app-loyalty-finish-form',
  templateUrl: './loyalty-finish-form.component.html',
  styleUrls: ['./loyalty-finish-form.component.scss']
})
export class LoyaltyFinishFormComponent implements OnInit {
  // @loyaltyDocs: loyalty-finish-form component
  // After registering in the loyalty system, this component displays the “continue” button
  // to the user and redirects the user to his bonus points

  @Input() agentState: AgentState;
  @Input() customerConfig: Customer;
  isDecisionMaker: boolean;
  accountLoading = true;
  readonly finishRegistrationMessage = $localize`:@@loyalty-finish-form.loyaltyFinishRegistrationYourNumber:Your Amadeus+Me membership number`;

  constructor(private readonly store: Store<any>, private readonly router: Router) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.store.dispatch(new AlreadyGetNumber(true));
  }

  finishRegistration() {
    this.router.navigate(['/amadeus-plus-me/bonuspoints']);
  }
}
